export { default } from './DestinationsBlock'
